import { FCX } from "@datassential/platform-ui-lib";
import ProfileSidebarToggle from "@components/ProfileSidebarToggle/ProfileSidebarToggle";
import "./CategoryProfileDivider.styles.scss";

interface Props {
    isCollapsed: boolean;
    onToggle: () => void;
}

const CategoryProfileDivider: FCX<Props> = ({ isCollapsed, onToggle }) => (
    <ProfileSidebarToggle
        className="CategoryProfileDivider"
        testId="blockCategoryProfileDivider"
        buttonTestId="buttonCategoryProfileSidebarCollapse"
        isCollapsed={isCollapsed}
        onToggle={onToggle}
    />
);

export default CategoryProfileDivider;
